import moduleLoader from "flow/wrappers/moduleLoader";
import MyFlow from "flow/MyFlow";
import persistentNotificationsHtml from "flow/viewModels/PersistentNotifications.html";

function getView(myFlow: MyFlow, url: string): JQueryPromise<string> {
    const dfd = myFlow.deferred<string>();

    let completeUrl;

    if (!url) {
        return dfd.resolve("<span></span>").promise();
    }

    if (url.indexOf("virtual/") === 0) {
        completeUrl = url;
    } else if (url.indexOf("text!") !== 0) {
        completeUrl = "text!" + myFlow.baseUrl + url;
    } else {
        completeUrl = url;
    }

    moduleLoader.requireSingleAsync(completeUrl).then(dfd.resolve).catch(dfd.reject);

    return dfd.promise();
}

function inject(url: string, view: string) {
    const windowAny = window as any;
    if (windowAny.define) {
        windowAny.define(url, function () {
            return view;
        });
    }
}

inject("virtual/persistentNotifications", persistentNotificationsHtml);

export default {
    getView: getView,
    inject: inject
};
